export default __webpack_public_path__ + "static/media/hero-img.53f1b546.png";